module.exports = __webpack_public_path__ + "media/images/photos/belgium-a2024dfdfa34561e0f83cf6f877fddf6.jpg";